import { useEffect, useState } from "react";
import classNames from "classnames";
import { DropDown, Typography } from "components/atoms";
import { Spinner } from "components/atoms/Icon";
import { FetchError } from "components/molecules/FetchErrorMsg";
import { BasicTable } from "../../../atoms/BasicTable";
import { decodeToken } from "utils/functions/decodeToken";
import { ACT_TEST_TYPE, GRE_TEST_TYPE } from "utils/constants";
import { useScreenSize } from "hooks";
import "./index.scss";

interface IProps {
  isMobile?: boolean;
  isTab?: boolean;
  data: any;
  isLoading: boolean;
  isError: boolean;
  theme?: "light" | "dark";
}
interface ContainerHeights {
  [key: string]: number | undefined;
}

export const PerformanceByTestsTable = ({
  isMobile,
  isTab,
  data,
  isLoading,
  isError,
  theme,
}: IProps) => {
  const [selectedTest, setSelectedTest] = useState<
    null | string | { [key: number]: string }
  >(null);

  const uniqueSubjectNames: Set<string> = new Set();
  const [containerHeights, setContainerHeights] = useState<ContainerHeights>(
    {}
  );
  const tableDataTesting: any[] = [];

  const payload = decodeToken();
  const screen = useScreenSize();

  const testType = payload ? payload.testtype : null;

  if (data) {
    data.map((value: any, index: number) => {
      value.TestScores.map((subject: any, index: number) => {
        uniqueSubjectNames.add(subject.SubjectName);
      });
    });
  }

  let subjectArray: string[] = Array.from(uniqueSubjectNames);

  if (data) {
    data.map((value: any, parentIndex: number) => {
      if (value.TestScores.length > 0) {
        subjectArray.map((item: string, childIndex: number) => {
          const scoreObject = value.TestScores.find(
            (score: any) => score.SubjectName === item
          );

          tableDataTesting.push({
            key: `${parentIndex}/${value.TestName}/${item}`,
            value: scoreObject ? scoreObject.Score : null,
          });
        });
      } else {
        subjectArray.map((item: string, index: number) => {
          tableDataTesting.push({
            key: `${parentIndex}/${value.TestName}/${item}`,
            value: null,
          });
        });
      }
    });
  }

  let rightTableHeaders: any = [];
  let rightTableData: any = [];
  const totalScoreData: any[] = [];
  let testNames: any = [];

  let nullScoreArray: any = [];

  if (data) {
    data.map((value: any, index: number) => {
      let isAllScoreNull = true;

      value.TestScores.map((scoreItem: any, index: number) => {
        if (scoreItem.Score !== null) {
          isAllScoreNull = false;
        }
      });

      nullScoreArray.push(isAllScoreNull);
    });
  }

  if (data) {
    data.map((value: any, index: number) => {
      value.hasOwnProperty("TestName") &&
        rightTableHeaders.push(value.TestName);
      value.hasOwnProperty("TestScore") &&
        totalScoreData.push(value.TestScore === 0 ? null : value.TestScore);

      value.hasOwnProperty("TestName") &&
        testNames.push({
          header: value.TestName,
          isData:
            value.TestScores.length === 0 || nullScoreArray[index]
              ? false
              : true,
        });

      let tempArray: any = [];

      value.hasOwnProperty("TestScores") &&
        value.TestScores.map((subject: any, index: number) => {
          tempArray.push(subject.Score);
        });

      rightTableData.push(tempArray);
    });
  }

  const tableScoreData: any[] = [];

  if (subjectArray.length > 0) {
    subjectArray.map((subject: string, ParentIndex: number) => {
      let tempScoreData: any[] = [];
      if (rightTableHeaders.length > 0) {
        rightTableHeaders.map((item: string, childIndex: number) => {
          let dataObject = tableDataTesting.find(
            (entry) => entry.key === `${childIndex}/${item}/${subject}`
          );

          if (dataObject) {
            tempScoreData.push(dataObject.value);
          }
        });
      }

      tableScoreData.push(tempScoreData);
    });
  }

  // Function to set padding based on performance-by-tests-thead height
  const setPadding = () => {
    // Get references to the elements
    const child1 = document.querySelector(".performance-by-tests-thead");
    const child2 = document.querySelector(".subject-section");

    if (child1 && child2) {
      const child1Height = (child1 as HTMLElement).offsetHeight;
      (child2 as HTMLElement).style.paddingTop = `${child1Height + 12}px`;
    }
  };

  // const child1 = document.querySelector(".performance-by-tests-tbody");
  // const child2 = document.querySelector(".subject-section");

  // const setHeight = () => {
  //   // Get references to the elements

  //   if (child1 && child2) {
  //     const child1Height = (child1 as HTMLElement).offsetHeight;
  //     console.log("child1Height", child1Height);

  //     (child2 as HTMLElement).style.height = `${child1Height}px`;
  //     if (
  //       !rightTableData.some((innerArray: any) =>
  //         innerArray.some((value: any) => value !== null)
  //       )
  //     ) {
  //       (child2 as HTMLElement).style.justifyContent = "flex-start";
  //     } else {
  //       (child2 as HTMLElement).style.justifyContent = "space-between";
  //     }
  //   }
  // };

  useEffect(() => {
    const heights: ContainerHeights = {};
    subjectArray.forEach((_, index) => {
      const container = document.querySelector(`#container${index}`);
      if (container) {
        heights[`container${index}`] = container.getBoundingClientRect().height;
      }
    });
    setContainerHeights(heights);
    // Set initial padding
  }, [screen.width]);

  useEffect(() => {
    setPadding();
    // setHeight();

    // Update padding if window is resized
    window.addEventListener("resize", setPadding);
    // window.addEventListener("resize", setHeight);

    return () => {
      // Cleanup event listeners
      window.removeEventListener("resize", setPadding);
      // window.removeEventListener("resize", setHeight);
    };
  }, []);

  return isLoading ? (
    <Spinner theme={theme} />
  ) : isError ? (
    <FetchError content="Oops! failed to load resources." />
  ) : (
    data && (
      <>
        {isMobile || isTab ? (
          <div className={classNames("perform-by-tests-mobile-wrapper")}>
            <Typography
              variant="h6Bold"
              label="View your scores between tests"
            />
            <DropDown
              setDropDownSelection={setSelectedTest}
              data={data.map((value: any, index: number) => value.TestName)}
              defaultSelected={selectedTest}
              placeholder="Select"
            />
            <div className={classNames("perform-by-tests-mobile-data-wrapper")}>
              {selectedTest &&
                typeof selectedTest === "object" &&
                data[parseInt(Object.keys(selectedTest)[0])].TestScores.map(
                  (value: any, index: number) => (
                    <div
                      key={index}
                      className={classNames(
                        "perform-by-tests-mobile-row-wrapper"
                      )}
                    >
                      <Typography variant="h8Med" label={value.SubjectName} />
                      <Typography
                        variant="h8Med"
                        label={Math.round(value.Score).toString()}
                      />
                    </div>
                  )
                )}
            </div>
          </div>
        ) : (
          <div className={classNames("perform-by-tests-desktop-wrapper")}>
            <Typography
              variant="h7Med"
              label="View your scores between tests:"
            />

            <div className="table-section">
              <div className="subject-section">
                {subjectArray.map((subject: string, index: number) => (
                  <div
                    className="data-holder"
                    id={`container${index}`}
                    key={`container${index}`}
                    // style={{
                    //   height:
                    //     containerHeights[`container${index}`] ||
                    //     "auto",
                    // }}
                  >
                    <Typography variant="h9Book" label={subject} />
                  </div>
                ))}
                {testType !== GRE_TEST_TYPE && (
                  <div className="data-holder">
                    <Typography
                      variant="h9Medium"
                      label={testType === ACT_TEST_TYPE ? "Composite" : "Total"}
                    />
                  </div>
                )}
              </div>
              <div className="data-section">
                <BasicTable
                  rules="columns"
                  columns={testNames}
                  data={tableScoreData}
                  renderHead={(customColumns: any) => (
                    <thead className={classNames("performance-by-tests-thead")}>
                      <tr>
                        {customColumns.map((obj: any, index: number) => (
                          <th key={index}>
                            <div
                              className={classNames({
                                "active-test": obj.isData === true,
                                "pending-test": obj.isData === false,
                              })}
                            >
                              {obj.header}
                            </div>
                          </th>
                        ))}
                      </tr>
                    </thead>
                  )}
                  renderBody={(customData) => (
                    <tbody className={classNames("performance-by-tests-tbody")}>
                      {!rightTableData.some((innerArray: any) =>
                        innerArray.some((value: any) => value !== null)
                      ) ? (
                        <tr>
                          <td
                            colSpan={testNames.length}
                            className="empty-message-table-data"
                          >
                            <div
                              className="empty-message-wrapper"
                              style={{
                                height: `${
                                  containerHeights &&
                                  Object.values(containerHeights).length > 0 &&
                                  Object.values(containerHeights).reduce(
                                    (acc: any, curr: any) => acc + curr,
                                    0
                                  )
                                }px`,
                              }}
                            >
                              <Typography
                                label="Take your first test to view your performance on this table"
                                variant="h8Book"
                              />
                            </div>
                          </td>
                        </tr>
                      ) : (
                        <>
                          {customData &&
                            customData.length > 0 &&
                            customData.map((obj, index) => (
                              <tr
                                key={index}
                                className="table-data-row"
                                style={{
                                  height:
                                    containerHeights[`container${index}`] ||
                                    "auto",
                                }}
                              >
                                {obj.map(
                                  (innerData: any, innerIndex: number) => (
                                    <td
                                      key={innerIndex}
                                      className={classNames("bold-text")}
                                    >
                                      {innerData}
                                    </td>
                                  )
                                )}
                              </tr>
                            ))}
                          {testType !== GRE_TEST_TYPE && (
                            <tr className="table-data-row">
                              {totalScoreData.map(
                                (innerData: any, innerIndex: number) => (
                                  <td
                                    key={innerIndex}
                                    className={classNames("total-text")}
                                  >
                                    {innerData}
                                  </td>
                                )
                              )}
                            </tr>
                          )}
                        </>
                      )}
                    </tbody>
                  )}
                />
              </div>
            </div>
          </div>
        )}
      </>
    )
  );
};
